<script setup lang="ts">
import { Card } from '@/components/ui/card'
import { formatPrice } from '@/helpers/current-price'
import { Deferred, router } from '@inertiajs/vue3'
import { useUrlSearchParams } from '@vueuse/core'
import { DollarSign } from 'lucide-vue-next'
import { PrimitiveProps } from 'reka-ui'
import { inject } from 'vue'
import { TotalStatusVariants, totalStatusVariants } from '.'

interface Props extends PrimitiveProps {
    variant?: TotalStatusVariants['variant']
    value: number
    status: string
}

const { status } = defineProps<Props>()

const params = inject('params', useUrlSearchParams())

function filterByStatus() {
    params.status = status
    router.reload({
        data: {
            ...params,
            status,
        },
        only: ['orders', 'pagination'],
    })
}
</script>

<template>
    <Deferred data="orders_by_status">
        <template #fallback>
            <div>Loading...</div>
        </template>
        <Card
            as="button"
            class="flex w-full cursor-pointer flex-col gap-4 border-none p-6 shadow-[0_6px_15px_-3px_rgba(209,213,220,0.25))]"
            @click="filterByStatus"
        >
            <div class="flex items-end justify-between">
                <span class="text-2xl font-semibold text-gray-800">
                    {{ formatPrice(value / 100) }}
                </span>
                <p :class="totalStatusVariants({ variant })">
                    <DollarSign class="size-4" />
                </p>
            </div>
            <span class="text-base">{{ $t(`Orders ${status}`) }}</span>
        </Card>
    </Deferred>
</template>
